export enum ReflectionGenderEnum {
  M = 'm',
  F = 'f',
}
